import BaseExtension from './base';

import { existy, first, createElement, extend } from '../utils';

/* eslint camelcase: 0 */

const MUX_OPTIONS = {
   page_type: 'watchpage',

   player_name: 'RavnurPlayer',
   player_version: '3.3.3',

   video_stream_type: 'on-demand'
};

export default class MuxExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options);
      this.logger.debug('mux:extension:creating');

      this.init();

      this.logger.debug('mux:extension:created');
   }

   init() {
      if ( existy(window.mux) ) {
         this.monitor();
      } else {
         this.loadLibraryAndStartMonitor();
      }
   }

   loadLibraryAndStartMonitor() {
      const script = createElement('script', { src: this.options.muxURL } );
      const firstScriptTag = first(document.getElementsByTagName('script'));
      script.onload = script.onreadystatechange = () => this.monitor();

      if (!firstScriptTag.parentNode) return;

      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
   }

   monitor() {
      const $el = this.player.getElement();
      const data = extend({}, MUX_OPTIONS, this.options.mux);
      window.mux.monitor(`#${$el.id}`, { debug: false, data });
   }

   destroy() {
      const $el = this.player.getElement();
      if ($el?.mux) {
         $el.mux.destroy();
      }
      super.destroy();
   }
}
